import { useMediaQuery } from 'react-responsive';
import cns from 'classnames';
import { match } from 'ts-pattern';
import S from './InquiryBanner.module.scss';
import { StoreBannerItem } from './types';
interface StoreBannerDescriptionProps {
  bannerData: StoreBannerItem;
}
export const StoreBannerDescription = ({
  bannerData
}: StoreBannerDescriptionProps) => {
  const isMobile = useMediaQuery({
    query: `(max-width: 679px)`
  });
  const DesktopDescription = <>
      <span className={S.subtitle}>{bannerData.subtitle}</span>
      <span className={cns(S.title, S.title_desktop)} style={{
      color: bannerData.titleColor
    }}>
        {bannerData.pcTitle}
      </span>
    </>;
  const MobileDescription = <>
      <span className={cns(S.title, S.title_mobile)} style={{
      color: bannerData.titleColor
    }}>
        {bannerData.mobileTitle}
      </span>
    </>;
  return <div className={S.description_wrapper} data-sentry-component="StoreBannerDescription" data-sentry-source-file="StoreBannerDescription.tsx">
      {match(isMobile).with(true, () => MobileDescription).with(false, () => DesktopDescription).exhaustive()}
    </div>;
};